import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import ApproversConfig from '../components/HRAdmin/ApproversConfig';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function ApproversConfigPage() {
    const classes = useStyles();
    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <ApproversConfig />
        </div>
    )
}